export default __webpack_public_path__ + "static/media/agriculture.99fbc145.png";